import React from 'react';
import { Sparkles } from 'lucide-react';
import OverlayCoverageList from '../VendorOverlayPicker/OverlayCoverageList';
import { VISIBILITY_CAPABILITIES, MATURITY_LEVELS } from '../config/ztaArchitectureData';

const ZtaVisibilityLayer = ({
  selectedDepartment,
  getCapabilityState,
  getCapabilitySuggestion,
  suggestionModeEnabled,
  coverageMap,
  effectiveSpendIndicators,
  setEditingVisibilityTool,
  openVendorDrillIn,
}) => {
  return (
    <section className="zta-layer zta-visibility-detail">
      <div className="zta-layer-label">VISIBILITY<br/>& ANALYTICS</div>
      <div className="zta-visibility-capabilities">
        {VISIBILITY_CAPABILITIES.map(cap => {
          const state = getCapabilityState(cap.id);
          const hasSavedState = state.capability_id || state.vendors !== undefined;
          const displayVendors = selectedDepartment && hasSavedState
            ? (state.vendors?.length ? state.vendors.join(' / ') : '')
            : cap.vendors;
          const suggestion = getCapabilitySuggestion ? getCapabilitySuggestion(cap.id) : null;
          const hasSuggestion = suggestionModeEnabled && suggestion?.detected?.length > 0 && !state.vendors?.length;
          // Vendor overlay coverages (sorted strongest first).
          const overlayCoverages = coverageMap[cap.id] || [];
          const hasOverlayCoverage = overlayCoverages.length > 0;
          const primaryOverlay = overlayCoverages[0];
          const currentMaturity = state.maturity || 'TRAD.';

          return (
            <button
              key={cap.id}
              className={`zta-vis-capability ${hasSuggestion ? 'zta-vis-capability--has-suggestion' : ''} ${hasOverlayCoverage ? 'zta-vis-capability--overlay-active' : ''}`}
              data-overlay-count={hasOverlayCoverage ? overlayCoverages.length : undefined}
              data-overlay-product={primaryOverlay?.productName}
              data-coverage-level={primaryOverlay?.coverageLevel}
              onClick={() => selectedDepartment && setEditingVisibilityTool(cap)}
              disabled={!selectedDepartment}
              title={selectedDepartment ? `Click to configure ${cap.name}` : 'Select a department first'}
            >
              {hasOverlayCoverage && (
                <OverlayCoverageList
                  coverages={overlayCoverages}
                  position="top"
                  spendIndicators={effectiveSpendIndicators}
                  onDrillIn={(v) => openVendorDrillIn({
                    ...v,
                    scope: 'capability',
                    code: cap.id,
                    name: `${cap.name} · ${v.product || v.vendor}`,
                  })}
                />
              )}
              {hasSuggestion && (
                <span className="zta-vis-suggestion-indicator" title={`Suggested: ${suggestion.topVendor}`}>
                  <Sparkles size={10} />
                </span>
              )}
              <div className="zta-vis-cap-header">
                <span className="zta-vis-cap-name">{cap.name}</span>
              </div>
              <div className="zta-vis-cap-vendors">
                {hasSuggestion && !displayVendors ? (
                  <span className="zta-vis-suggestion-text">{suggestion.topVendor}</span>
                ) : (
                  displayVendors || cap.vendors
                )}
              </div>
              {/* Maturity indicator bar */}
              <div className="zta-vis-maturity-bar">
                {MATURITY_LEVELS.map((level, idx) => {
                  const currentIdx = MATURITY_LEVELS.indexOf(currentMaturity);
                  const isActive = idx <= currentIdx;
                  const levelColors = {
                    'TRAD.': '#71717a',
                    'INITIAL': '#eab308',
                    'ADVANCED': '#3b82f6',
                    'OPTIMAL': '#22c55e'
                  };
                  return (
                    <div
                      key={level}
                      className={`zta-vis-maturity-segment ${isActive ? 'active' : ''}`}
                      style={{ backgroundColor: isActive ? levelColors[level] : 'var(--zta-border)' }}
                      title={level}
                    />
                  );
                })}
              </div>
              <div className="zta-vis-maturity-label">{currentMaturity}</div>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default ZtaVisibilityLayer;
